// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"_2wcSV","notification":"_10pyy"};